import { ActionIcon, TextInput } from '@mantine/core'
import { IconArrowRight, IconSearch } from '@tabler/icons-react'
import OrderHistory from 'components/orders/OrderHistory'
import { useState } from 'react'

export default function CheckOrderHistoryModal() {
  const [searchValue, setSearchValue] = useState('')
  const [searchedValue, setSearchedValue] = useState('')
  const [key, setKey] = useState(0)

  function handleSearch() {
    setSearchValue(searchValue.trim())
    setSearchedValue(searchValue.trim())
    setKey((prevKey) => prevKey + 1)
  }

  return (
    <>
      <TextInput
        data-autofocus
        placeholder="Z-123"
        description="Wpisz numer zamówienia, numer telefonu, email lub imię i nazwisko, aby sprawdzić historię zamówień."
        inputWrapperOrder={['input', 'description']}
        radius="xl"
        rightSectionWidth={35}
        leftSection={<IconSearch size={18} stroke={1.5} />}
        rightSection={
          <ActionIcon size={28} radius="xl" variant="filled" onClick={handleSearch}>
            <IconArrowRight size={18} stroke={1.5} />
          </ActionIcon>
        }
        value={searchValue}
        onChange={(event) => setSearchValue(event.currentTarget.value)}
        onKeyDown={(event) => event.key === 'Enter' && handleSearch()}
        mb="lg"
      />
      <OrderHistory key={key} search={searchedValue} />
    </>
  )
}
